var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveCitizenf1Afbc46(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 51.5C4.75 51.5 0.5 51.5 0.5 47.25C0.5 43 4.75 30.25 26 30.25C47.25 30.25 51.5 43 51.5 47.25C51.5 51.5 47.25 51.5 47.25 51.5H4.75ZM26 26C29.3815 26 32.6245 24.6567 35.0156 22.2656C37.4067 19.8745 38.75 16.6315 38.75 13.25C38.75 9.86849 37.4067 6.62548 35.0156 4.23439C32.6245 1.8433 29.3815 0.5 26 0.5C22.6185 0.5 19.3755 1.8433 16.9844 4.23439C14.5933 6.62548 13.25 9.86849 13.25 13.25C13.25 16.6315 14.5933 19.8745 16.9844 22.2656C19.3755 24.6567 22.6185 26 26 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 51.5C4.75 51.5 0.5 51.5 0.5 47.25C0.5 43 4.75 30.25 26 30.25C47.25 30.25 51.5 43 51.5 47.25C51.5 51.5 47.25 51.5 47.25 51.5H4.75ZM26 26C29.3815 26 32.6245 24.6567 35.0156 22.2656C37.4067 19.8745 38.75 16.6315 38.75 13.25C38.75 9.86849 37.4067 6.62548 35.0156 4.23439C32.6245 1.8433 29.3815 0.5 26 0.5C22.6185 0.5 19.3755 1.8433 16.9844 4.23439C14.5933 6.62548 13.25 9.86849 13.25 13.25C13.25 16.6315 14.5933 19.8745 16.9844 22.2656C19.3755 24.6567 22.6185 26 26 26Z",
    fill: "url(#paint0_linear_10744_25522)",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 51.5C4.75 51.5 0.5 51.5 0.5 47.25C0.5 43 4.75 30.25 26 30.25C47.25 30.25 51.5 43 51.5 47.25C51.5 51.5 47.25 51.5 47.25 51.5H4.75ZM26 26C29.3815 26 32.6245 24.6567 35.0156 22.2656C37.4067 19.8745 38.75 16.6315 38.75 13.25C38.75 9.86849 37.4067 6.62548 35.0156 4.23439C32.6245 1.8433 29.3815 0.5 26 0.5C22.6185 0.5 19.3755 1.8433 16.9844 4.23439C14.5933 6.62548 13.25 9.86849 13.25 13.25C13.25 16.6315 14.5933 19.8745 16.9844 22.2656C19.3755 24.6567 22.6185 26 26 26Z",
    fill: "url(#paint1_linear_10744_25522)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10744_25522",
    x1: 51.5,
    y1: 51.5,
    x2: 0.5,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10744_25522",
    x1: 0.5,
    y1: 0.5,
    x2: 50.5288,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCitizenf1Afbc46);
export default __webpack_public_path__ + "static/media/active-citizen.f1afbc46.2af495cb7b04b3e9f4f8f632b4f5bd57.svg";
export { ForwardRef as ReactComponent };